import colors, { palette } from '../colors';
export default {
  primary: {
    backgroundColor: palette.primary,
    color: colors.white
  },
  "default": {
    backgroundColor: colors.paleGrey,
    color: colors.bluishGrey
  },
  success: {
    backgroundColor: palette.success,
    color: colors.white
  },
  warning: {
    backgroundColor: palette.warning,
    color: colors.white
  },
  error: {
    backgroundColor: palette.error,
    color: colors.white
  }
};